
import { ClientTherapistRelationship } from "@/types/therapist";

export const getInitials = (name: string): string => {
  if (!name || name.startsWith('Client ID:')) return 'C';
  
  const nameParts = name.split(' ').filter(Boolean);
  if (nameParts.length === 0) return 'C';
  
  if (nameParts.length === 1) {
    return nameParts[0].charAt(0).toUpperCase();
  }
  
  return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
};

export const getAvatarColor = (name: string): string => {
  if (!name || name.startsWith('Client ID:')) return 'bg-[#3BAFDA]';
  
  const colors = [
    'bg-[#333B44]', 'bg-[#3BAFDA]', 'bg-green-600', 
    'bg-amber-600', 'bg-rose-600', 'bg-cyan-600'
  ];
  
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  return colors[Math.abs(hash) % colors.length];
};
